define('model/template.type.template.object.type.model',['require','exports','module','fukit'],function(require, exports, module) {
  var BaseModel = require('fukit').BaseModel;

  var TemplateTypeTemplateObjectType = BaseModel.extend({
    radioRequests: {
      'models TemplateTypeTemplateObjectType': '@constructor',
    },

    urlRoot: '/api/v1/eform/templateTypeTemplateObjectType',

    virtual: {
      description: 'templateObjectType.description',
    },

    childModels: {
      templateObjectType: 'TemplateObjectType',
    },
  });

  module.exports = TemplateTypeTemplateObjectType;
});

